import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
//import JsBarcode from '../../../assets/js/render-js-barcode.js'


import * as JsBarcode 
    from '../../../assets/js/render-js-barcode.js'

import * as JsBarcodeImage 
    from '../../../assets/js/render-js-barcode-image.js'

    
@Component({
  selector: 'app-datamatrix-barcode',
  templateUrl: './datamatrix-barcode.component.html',
  styleUrls: ['./datamatrix-barcode.component.css'],
})
export class DatamatrixBarcodeComponent implements OnChanges {

  @Input() BarcodeData: string | undefined;
  @Input() RenderImage: boolean | undefined;

  public ngOnChanges(): void {
    if(this.BarcodeData!=null){
      if (this.RenderImage==null||this.RenderImage==true) {
        setTimeout(() => {
          JsBarcodeImage.render(this.BarcodeData);
        }, 20);
      }else{
        setTimeout(() => {
          JsBarcode.render(this.BarcodeData);
        }, 20);
      }
    }
  }

}
